// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDauDFYxVYKweRJm3mIj1G_nQCMBmBrRNE",
  authDomain: "saehan-system.firebaseapp.com",
  projectId: "saehan-system",
  storageBucket: "saehan-system.appspot.com",
  messagingSenderId: "360803649298",
  appId: "1:360803649298:web:86de477bb18d569ff315cb",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const db = getFirestore(app);
